class AgeVerificationPopup extends ModalDialog {
  constructor() {
    super();
    if (Shopify.designMode) {
      window.addEventListener('shopify:section:load', this.init.bind(this));
    }
    this.init();
  }

  init() {
    this.ageVerified = getCookie("age-verified") === "true";
    this.pendingUrl = null;

    this.restrictedHandles = (this.dataset.restrictedHandles || '')
      .split(',')
      .map((h) => h.trim())
      .filter(Boolean);
    this.restrictedProductHandles = (this.dataset.restrictedProductHandles || '')
      .split(',')
      .map((h) => h.trim())
      .filter(Boolean);
    this.currentRestricted = this.dataset.currentRestricted === 'true';

    this.noButton = this.querySelector(".button-no");
    this.yesButton = this.querySelector(".button-yes");

    // other popup elements
    this.newsletterPopup = document.getElementById(
      "NewsletterModal-newsletter-popup"
    );

    this.attachButtonListeners();
    this.attachLinkInterceptor();

    setTimeout(() => {
      if (this.hasAttribute("open") && this.classList.contains('age-verification-popup--blurred')) {
        document.body.classList.add("age-verification-popup-is-open");
      }
    }, 5000);
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    this.showPopupIfNecessary();
  }

  showPopupIfNecessary() {
    if (this.ageVerified) return;
    if (!this.currentRestricted) return;

    if (this.newsletterPopup) {
      this.newsletterPopup.classList.add("newsletter-popup-is-hidden");
    }
    this.show();
  }

  isRestrictedUrl(url) {
    if (!this.restrictedHandles.length && !this.restrictedProductHandles.length) return false;
    let parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return false;
    }
    if (parsed.origin !== window.location.origin) return false;

    const collectionMatch = parsed.pathname.match(/^\/collections\/([^\/]+)/);
    if (collectionMatch && this.restrictedHandles.includes(collectionMatch[1])) return true;

    const productMatch = parsed.pathname.match(/^\/products\/([^\/]+)/);
    if (productMatch && this.restrictedProductHandles.includes(productMatch[1])) return true;

    return false;
  }

  attachLinkInterceptor() {
    if (!this.restrictedHandles.length && !this.restrictedProductHandles.length) return;
    if (this._linkInterceptorAttached) return;
    this._linkInterceptorAttached = true;

    document.addEventListener('click', (event) => {
      if (this.ageVerified) return;
      if (event.defaultPrevented) return;
      if (event.button !== undefined && event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href]');
      if (!link) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;
      if (!this.isRestrictedUrl(link.href)) return;

      event.preventDefault();
      this.pendingUrl = link.href;
      if (this.newsletterPopup) {
        this.newsletterPopup.classList.add("newsletter-popup-is-hidden");
      }
      this.show();
    }, true);
  }

  attachButtonListeners() {
    if (this.noButton) {
      this.noButton.addEventListener("click", () => {
        setCookie("age-verified", "false");
        this.handleNoButtonClick();
      });
    }

    if (this.yesButton) {
      this.yesButton.addEventListener("click", () => {
        this.setAgeVerifiedTrue();
        const next = this.pendingUrl;
        this.pendingUrl = null;
        this.hide();
        if (next) {
          window.location.href = next;
        }
      });
    }
  }

  setAgeVerifiedTrue() {
    this.ageVerified = true;
    setCookie("age-verified", "true", 365);
  }

  handleNoButtonClick() {
    if (this.pendingUrl) {
      this.pendingUrl = null;
      this.hide();
      return;
    }
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = this.noButton.href;
    }
  }

  show() {
    super.show();

    if (this.classList.contains('age-verification-popup--blurred')) {
      document.body.classList.add("age-verification-popup-is-open");
    }
  }

  hide() {
    super.hide();

    document.body.classList.remove("age-verification-popup-is-open");

    if (this.getAttribute("data-open-in-design-mode")) {
      this.removeAttribute("data-open-in-design-mode");
    }

    if (this.newsletterPopup) {
      this.newsletterPopup.classList.remove(
        "newsletter-popup-is-hidden"
      );
    }
  }
}

customElements.define("age-verification-popup", AgeVerificationPopup);
